import React, { useContext } from 'react';

import DeviceSyncMergesContext from '@totem/components/administration/deviceSyncMerges/DeviceSyncMergesContext';
import DeviceSyncMergesFilters from '@totem/components/administration/deviceSyncMerges/DeviceSyncMergesFilters';
import DeviceSyncMergesTable from '@totem/components/administration/deviceSyncMerges/DeviceSyncMergesTable';

export const DeviceSyncMergesExtra = () => {
  const { totalRecords, loading } = useContext(DeviceSyncMergesContext);
  if (loading) {
    return null;
  }
  return <span>{totalRecords} conflicts</span>;
};

const DeviceSyncMergesLayout = () => (
  <>
    <p>
      Device syncs that found more than one device for the same key. The sync
      skips these devices until the conflict is resolved: merge the devices into
      the one to keep, or dismiss the conflict if they are genuinely different
      devices.
    </p>
    <DeviceSyncMergesFilters />
    <DeviceSyncMergesTable />
  </>
);

export default DeviceSyncMergesLayout;
